/* eslint-disable */
import { produce } from "immer";
import {
  FUND_SWITCH_FETCH_FAILURE,
  FUND_SWITCH_FETCH_SUCCESS,
  FUND_SWITCH_FETCH_START,
} from "../actions/types";

const fundSwitch = (
  state = {
    fundSwitchFetching: false,
    fundSwitchData: [],
    fundSwitchError: null,
  },
  action,
) => {
  switch (action.type) {
    case FUND_SWITCH_FETCH_START:
      return produce(state, (draft) => {
        draft.fundSwitchFetching = true;
      });
    case FUND_SWITCH_FETCH_SUCCESS:
      return produce(state, (draft) => {
        draft.fundSwitchFetching = true;
        draft.fundSwitchData = action.data;
        draft.fundSwitchFetching = false;
      });
    case FUND_SWITCH_FETCH_FAILURE:
      return produce(state, (draft) => {
        draft.fundSwitchFetching = false;
        draft.fundSwitchError = action.error;
      });
    default:
      return state;
  }
};

export default fundSwitch;
